import * as React from "react"
import { Link } from "gatsby"
import * as styles from './sidebar.module.css'
import './sidebar.scss'
import isBrowser from '../../isBrowser'
import M from 'materialize-css'
const Sidebar = ({ menu }) => {

  React.useEffect(() => {

    const abortControl = new AbortController();

    if (isBrowser()){

      var elem = document.querySelector('#menu-bar')

      M.Sidenav.init(elem, {
        edge:"right",
        preventScrolling:true
      })

      M.Collapsible.init(document.querySelectorAll('.collapsible'), {})

      elem.querySelectorAll('a').forEach(anchorTag => {
        anchorTag.addEventListener('click', function (e) {
          if ( e.target.href === window.location.href || e.target.getAttribute('href') === "/#!" )
          {
            e.preventDefault();
            return null;
          }else{
            var instance = M.Sidenav.getInstance(elem);
            instance.close();
          }
        })
      })
    }

    return () => { abortControl.abort(); }

  }, [])

  return (
    <ul id="menu-bar" className="sidenav">
      <li className="company-logo">
        <Link to="/">
          <img className={ styles.logo }
            src={`/logo_png/navbar.png`}
            alt="Mr.Pentester"
          />
        </Link>
      </li>
      <hr/>
      {
        menu.map((item, i)=>(
          <li key={i}>
            <ul className={ item.isSubmenu ? "collapsible collapsible-accordion" : null }>
              <li>
                {
                  item.externalLink ? 
                  <a href={ item.path } target="_blank" rel="noopener noreferrer">
                        { item.name }
                  </a> :
                  <Link to={item.path} className={ item.isSubmenu ? "collapsible-header" : null }>
                    { item.name }
                    { item.isSubmenu &&  <i className="fa fa-plus right"></i> }
                  </Link>
                }
                {
                  item.isSubmenu &&
                  <div className="collapsible-body">
                    <ul>
                      {
                        Object.keys(item.menu).map((keyName, i) => (
                          <li className="col" key={i}>
                            {
                              keyName && (
                                <>
                                  <span>{ keyName }</span>
                                  <hr/>
                                </>
                              )
                            }
                            <ul>
                              {
                                item.menu[keyName].map((service, j)=>(
                                  <li key={j}>
                                    <Link to={service.path}>
                                      {service.title}
                                    </Link>
                                  </li>
                                ))
                              }
                            </ul>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                }
              </li>
            </ul>
            
          </li>
        ))
      }
      <span className="buttons">
        <li>
          <Link to='/log_in' className="btn login">
            Login
          </Link>
        </li>
        <li>
          <Link to='/' className="btn under-attack">
            Under Attack?
          </Link>
        </li>
      </span>
    </ul>
  )
}



export default Sidebar
